import { render, staticRenderFns } from "./basePopPanel.vue?vue&type=template&id=e706349c&scoped=true&"
import script from "./basePopPanel.vue?vue&type=script&lang=js&"
export * from "./basePopPanel.vue?vue&type=script&lang=js&"
import style0 from "./basePopPanel.vue?vue&type=style&index=0&id=e706349c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e706349c",
  null
  
)

export default component.exports